import { helpers } from '@berkshireassociates/berkshirecomponents'

export const getComputedColor = helpers.theme.getComputedColor
export const getColorWithOpacity = helpers.theme.getColorWithOpacity
